import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function CodePhaseIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5332 5.52833C12.6451 5.16506 13.0167 4.9385 13.3975 5.01466C13.7781 5.09098 14.0336 5.443 13.9971 5.8213L13.9854 5.89747L11.4854 18.3975C11.4039 18.8034 11.0086 19.0666 10.6025 18.9854C10.1966 18.904 9.93344 18.5086 10.0146 18.1025L12.5146 5.60255L12.5332 5.52833ZM7.73926 8.2002C8.04275 7.91838 8.51794 7.93584 8.7998 8.23926C9.08162 8.54276 9.06417 9.01795 8.76074 9.29981L5.85254 12L8.76074 14.7002L8.81348 14.7559C9.06444 15.0414 9.06403 15.4762 8.7998 15.7607C8.53558 16.0452 8.10206 16.0777 7.79883 15.8486L7.73926 15.7998L4.23926 12.5498C4.0865 12.4079 4 12.2085 4 12C4 11.7915 4.0865 11.5921 4.23926 11.4502L7.73926 8.2002ZM15.2002 8.23926C15.4644 7.95483 15.8979 7.92227 16.2012 8.15137L16.2607 8.2002L19.7607 11.4502L19.8145 11.5059C19.9336 11.6419 20 11.8174 20 12C20 12.1826 19.9336 12.3581 19.8145 12.4941L19.7607 12.5498L16.2607 15.7998C15.9572 16.0816 15.4821 16.0642 15.2002 15.7607C14.9184 15.4573 14.9358 14.9821 15.2393 14.7002L18.1465 12L15.2393 9.29981L15.1865 9.24415C14.9356 8.95866 14.936 8.52381 15.2002 8.23926Z"
        fill="currentColor"
      />
    </svg>
  );
};
